import { render, staticRenderFns } from "./user-photos.vue?vue&type=template&id=22f1bb4f"
import script from "./user-photos.vue?vue&type=script&lang=js"
export * from "./user-photos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports